module.exports = __webpack_public_path__ + "static/img/star-on.e8208669.svg";